import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { GetOrderHeadsPagedParams, OrderHeadItem, OrderheadService, OrderHeadsGet } from '@app/services/orderhead.service';
import { debounceTime, from, Subject, switchMap, tap } from 'rxjs';

@Component({
    selector: 'tt-order-heads-paged',
    templateUrl: './order-heads-paged.component.html',
    styleUrls: ['./order-heads-paged.component.css'],
})
export class OrderHeadsPagedComponent implements OnChanges {
    @Input()
    public params?: OrderHeadsGet;

    public orderheads: OrderHeadItem[] = [];

    public page = 0;

    public pageSize = 10;

    public total = 0;

    public load$ = new Subject<GetOrderHeadsPagedParams>();

    public pageSizeArray = new Array(this.pageSize);

    public loading = false;

    constructor(
        private orderhead: OrderheadService,
        private cdr: ChangeDetectorRef,
    ) {
        this.load$
            .pipe(
                tap({
                    next: () => {
                        this.pageSizeArray = new Array(this.pageSize);
                        this.loading = true;
                    },
                }),
                debounceTime(150),
                switchMap((params) => from(this.orderhead.getOrderHeadsPaged(params))),
            )
            .subscribe({
                next: (response) => {
                    this.orderheads = response.items;
                    this.total = response.total;
                    this.loading = false;

                    this.cdr.markForCheck();
                    this.cdr.detectChanges();
                },
            });
    }

    public async loadOrderHeads() {
        if (!!this.params) {
            this.load$.next({ ...this.params, webpage: `orderheads/${this.params.argtype}/${this.params.argvalue}`, page: this.page + 1, pageSize: this.pageSize });
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        console.log('changes');
        if (changes['params']) {
            this.loadOrderHeads();
        }
    }
}
